import React from 'react'
import { TextField, Text } from '@fluentui/react'
import classNames from 'classnames'
import styles from 'styles/components/inputs/refuse-reason-field.module.scss'

/**
 * @param {object} props Props
 * @param {string} props.label label
 * @param {string} props.value  value
 * @param {(value: string) => void} props.onChange onChange
 * @param {number} props.maxLength maxLength
 * @param {string|null} [props.errorMessage] errorMessage
 * @param {string} props.remainingText reamingText
 * @param {number} props.remaining remaining
 * @param {boolean} props.disabled disabled
 * @param {boolean} props.readOnly readOnly
 * @param {string|null} props.error error
 * @returns {JSX.Element} Element
 */
export default function RefuseReasonOrderQuoteInput({
    label,
    value,
    onChange,
    maxLength,
    disabled,
    readOnly,
    error,
    errorMessage = error,
    remainingText,
    remaining,
}) {
    return (
        <div>
            {label && <p>{label}</p>}
            <TextField
                value={value}
                multiline
                rows={4}
                resizable={false}
                maxLength={maxLength}
                disabled={disabled}
                readOnly={readOnly}
                onChange={(_, newVal) => onChange(newVal)}
                styles={{
                    field: {
                        color: errorMessage ? '#a80000' : undefined,
                    },
                }}
            />

            {!errorMessage && (
                <Text
                    className={classNames(
                        styles['error-message'],
                        { [styles['error-message--warning']]: remaining <= 20 },
                    )}
                >
                    {remainingText}
                </Text>
            )}

            {errorMessage && !disabled && !readOnly && (
                <div className={styles['error-message-container']}>
                    {errorMessage}
                </div>
            )}
        </div>
    )
}
